var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HeadingTag } from '@marketing/components/global/typography/Heading/Heading';
import FlexSection from '@marketing/components/sections/FlexSection';
import FAQAccordion from '@marketing/components/sections/non_product/FAQ/FAQAccordion';
import Image from '@marketing/components/sections/non_product/Media/Image';
function StoreServePrep(_a) {
    var content = _a.content;
    var imageData = content.imageData, faqs = content.faqs;
    var headline = 'Nom Nom Tips';
    return (_jsxs(FlexSection, __assign({ backgroundColorStyle: "bg-surface-beige", paddingStyle: "px-2xs-gutter py-sm-gutter md:px-3xl-gutter md:py-lg-gutter", gapStyle: "gap-xl-m md:gap-lg-m", className: "!items-start" }, { children: [_jsx(HeadingTag, __assign({ as: "h2", size: "xl", className: "md:hidden" }, { children: headline })), _jsx(Image, { className: "w-full aspect-[288/240] md:w-auto md:h-[417px] md:aspect-[506/417] rounded-[21px]", imageData: imageData }), _jsxs("div", __assign({ className: "flex flex-col gap-xl-m w-full md:w-[380px]" }, { children: [_jsx(HeadingTag, __assign({ as: "h2", size: "xl", className: "hidden md:block" }, { children: headline })), _jsx("div", __assign({ className: "flex flex-col justify-start gap-xs-m" }, { children: faqs.map(function (faq, index) { return (_jsx(FAQAccordion, __assign({}, faq), index)); }) }))] }))] })));
}
export default StoreServePrep;
